import { render } from "./MediaLibPage.vue?vue&type=template&id=31570011"
import script from "./MediaLibPage.vue?vue&type=script&lang=ts"
export * from "./MediaLibPage.vue?vue&type=script&lang=ts"
script.render = render

export default script